import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./theme";
import { AuthProvider, useAuth } from "./auth";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Traces from "./pages/Traces";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Incidents from "./pages/Incidents";
import Subscribers from "./pages/Subscribers";
import Me from "./pages/Me";
import Docs from "./pages/Docs";
import Organizations from "./pages/Organizations";
import OrganizationDetail from "./pages/OrganizationDetail";
import type { ReactNode } from "react";

function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <p style={{ padding: 16 }}>Cargando…</p>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              }
            >
              <Route index element={<Navigate to="/traces" replace />} />
              <Route path="traces" element={<Traces />} />
              <Route path="services" element={<Services />} />
              <Route path="services/:slug" element={<ServiceDetail />} />
              <Route path="incidents" element={<Incidents />} />
              {/* `/incidents/:id` ya no es una ruta separada — el detalle se
                  abre en modal desde la lista. Si querés deep-linking, hay
                  que reintroducir la ruta y leer el query param. */}
              <Route path="subscribers" element={<Subscribers />} />
              <Route path="me" element={<Me />} />
              <Route path="docs" element={<Docs />} />
              <Route path="organizations" element={<Organizations />} />
              <Route path="organizations/:id" element={<OrganizationDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
